var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.svgClass,attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}}),_vm._v(" "),(_vm.iconClass=='icon_tips')?_c('text',{style:(_vm.tipsStyle),attrs:{"x":"20","y":"9","text-anchor":"middle","dominant-baseline":"middle","fill":"#fff"}},[_vm._v(_vm._s(_vm.tips))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }